require('./css/article.css');
// require('./../sprite/sprite_common.css');
var helper = require('./module/helper/helper.js');
var article_tpl = require('./index2.hbs');
var data = window.data;
var postid = helper.url.GetQueryString("postid")?helper.url.GetQueryString("postid"):(data?data.postid:"");
var type = helper.url.GetQueryString("type")?helper.url.GetQueryString("type"):(data?data.type:"");
var appVersion = helper.url.GetQueryString("version")?helper.url.GetQueryString("version"):(data?data.version:"");
var plat = helper.url.GetQueryString("plat")?helper.url.GetQueryString("plat"):(data?data.plat:"");
var theme = helper.url.GetQueryString("theme")?helper.url.GetQueryString("theme"):(data?data.theme:"");
var product = helper.url.GetQueryString("product")?helper.url.GetQueryString("product"):(data?data.product:"");
var SysFrom = data?data.SysFrom:"";

try {appPlat} catch (e) {appPlat = 100000}

var data = {
	product:product,
	version:appVersion,
	type:type?type:0,
	plat:plat,
	theme:theme,
	showArticle:"hide",
	showNoArticle:"hide",
	post:{},
	post_id:"",
	user_id:"0",
	user_v:"",
	user_nickname:"",
	user_influ_level:0,
	// user_is_followed:false,
	// user_is_following:false,
	// user_is_following_each:false,
	isfollow:"notfollow",
	user_age:"",
	post_display_time:"",
	post_publish_time:"",
	post_from:"",
	isShowPdf:"hide",
	post_pic_url:[],
	post_pdf_url:"",
	post_content:"",
	post_abstract:"",
	post_title:"",
	post_click_count:"",
	stockbar_name:"",
	post_like_count:"",
	barUrl:"",
	post_is_like:"unlike",
	user_is_majia:false,
	stockbar_quote:0,
	stockbar_code:0,
	stockbar_exchange:0,
	isShowDT:false,
	isMajia:"hide",
	isMajiaOrPostUser:"show",
	isShowTitle:"hide",
	Pic9Height:"0",
	passing:false, // 帖子是否在审核中
}

function getUserFollowingAndBlackInfo(){
	// var url = "https://gubaapi4appnocorehttps.eastmoney.com/read/api/Follow/GetUserFollowingAndBlackInfo";
	// var url = "https://gbapi.eastmoney.com/follow/api/Follow/GetUserFollowingAndBlackInfo";
	// if(!helper.env.isRelease){
		// url = "http://gubaapi4appnocore-test.eastmoney.com/read/api/Follow/GetUserFollowingAndBlackInfo";
		// url = "http://gbapi-test.eastmoney.com/follow/api/Follow/GetUserFollowingAndBlackInfo";
	// }
	helper.user.checkLogin(function(){
		if(helper.user.isLogin()){
			if(data.post.post_state == 2){  // 审核中的帖子
				if(helper.user.uid == data.user_id){  // 本人的审核中的帖子

				}else{ // 如果帖子在审核中，并且自己不是作者， 那么显示没有该帖
					data.showArticle = "hide";
					data.showNoArticle = "blockShow";
					document.getElementsByClassName("article_wrap")[0].className = "article_wrap hide";
					document.getElementById("no_article").className = "no_article blockShow";
				}
			}

			// helper.net.jsonp(url, {    //7.7
			// 	myuid: helper.user.uid,
			// 	uid: data.user_id
			// }, "jsonp").success(function(res){
			helper.net.getjsonp_core({
				url:"/follow/api/Follow/GetUserFollowingAndBlackInfo",  // 7.8
				data:{
						myuid: helper.user.uid,
						uid:data.user_id
				},
				type:"POST",
				success:function(res){
					data.isfollow = res.re.is_following?"isfollowed":"notfollow";
					if(data.isfollow == "isfollowed"){ //关注了
						document.getElementById("follow_wrap").children[0].className = "follow_btn follow right show";
						document.getElementById("follow_wrap").children[1].className = "follow_btn unfollow right hide";
					}else{ //没关注
						document.getElementById("follow_wrap").children[0].className = "follow_btn follow right hide";
						document.getElementById("follow_wrap").children[1].className = "follow_btn unfollow right show";
					}

					data.post.post_user.is_blacked = res.re.is_blacked;
					data.post.post_user.is_blackuser = res.re.is_blackuser;

					// 如果自己被作者黑名单了，那么不显示关注按钮；如果是看自己的帖子，就隐藏关注；
					if(data.post.post_user.is_blacked == 1 || helper.user.uid == data.user_id){
						data.isMajiaOrPostUser = "hide";
						document.getElementById("follow_wrap").className += " hide";
					}

					var info2 = {
						"topData": {
							"subscribeStatus":res.re.is_following,
							"is_blackuser":res.re.is_blackuser,
							"is_blacked":res.re.is_blacked,
						}
					}
					helper.Bridge.emSendBackInfoToAPP(info2);
				}
			})
		}else{
			if(data.post.post_state == 2){  // 审核中的帖子
				data.showArticle = "hide";
				data.showNoArticle = "blockShow";
				document.getElementsByClassName("article_wrap")[0].className = "article_wrap hide";
				document.getElementById("no_article").className = "no_article blockShow";
			}

			var info2 = {
				"topData": {
					"subscribeStatus":false,
					"is_blackuser":false,
					"is_blacked":false,
				}
			}
			helper.Bridge.emSendBackInfoToAPP(info2);
		}
	})
}

function emSendPageInfoToAPP(){
	if(!data.post){
		var info1 = {
			"shareData":{
				"title": "",
				"url": "",
				"img": "http://gbfek.dfcfw.com/libs/share/weixin-share.png",
				"desc": "",
				"stockbar_name": "",  //所属吧
				"user_nickname": "",  //作者
				"post_publish_time": "",  //发布时间
				"first_pic": "", // 第一张图
			},
			"topData": {
				"portrait": "http://avator.eastmoney.com/qface//166",
				"nickname": "",
				"url": "",
				"callbackname": "handleFollowUser",
				"callbackname_skip": "handleJump",
				"height":66
			},
			"pageMethods":{
				// "setTheme":"setTheme",
			},
			"readData":{}
		}
		helper.Bridge.emSendPageInfoToAPP(info1);
		return ;
	}
	var time = data.post.post_publish_time?data.post.post_publish_time:"";
	var year = new Date();
	if(!time){
		if(time.substr(0,4) == year.getFullYear()){
			time = time.substring(5,16);
		}else{
			time = time.substring(0,16);
		}
	}

	var info1 = {
		"shareData":{
			"title": !data.post_title?data.post_content:data.post_title,
			"url": "http://mguba.eastmoney.com/mguba/article/0/"+data.user_id,
			"img": "http://gbfek.dfcfw.com/libs/share/weixin-share.png",
			"desc": data.user_nickname,
			"stockbar_name": data.post.post_guba.stockbar_name,  //所属吧
			"user_nickname": data.post.post_user.user_nickname,  //作者
			"post_publish_time": data.post.post_publish_time,  //发布时间
			"first_pic": data.post.post_pic_url2.length>0?data.post.post_pic_url2[0]:"", // 第一张图
		},
		"topData": {
			"portrait": "http://avator.eastmoney.com/qface/"+ data.user_id +"/166",
			"nickname": data.user_nickname,
			"url": "http://mguba.eastmoney.com/mguba/article/0/"+data.post_id,
			"callbackname": "handleFollowUser",
			"callbackname_skip": "handleJump",
			"height":66
		},
		"pageMethods":{
			// "setTheme":"setTheme",
		},
		"readData":data.post
	}
	helper.Bridge.emSendPageInfoToAPP(info1);
}

function addScrollListener(e){
	var scrollTop = 0;
	if(document.documentElement){
		scrollTop = document.documentElement.scrollTop;
	}
	if(document.body){
		scrollTop = document.body.scrollTop;
	}
	if(data.isShowDT){
		if(scrollTop < 66){
			data.isShowDT = !data.isShowDT;
			helper.Bridge.scrollToShow(0);
		}
	}else{
		if(scrollTop > 66){
			data.isShowDT = !data.isShowDT;
			helper.Bridge.scrollToShow(1);
		}
	}
}

// type 1:普通帖 2:转发原贴
function handleImageWrap(image_align_type,isOnePic,type) {
	if(type == "1"){
		var images_a = document.querySelectorAll('.image_wrap>a');
		var img_wrap = document.querySelectorAll('.image_wrap')[0];
		if(isOnePic){
			images_a[0].style.width = "100%";
			images_a[0].style.height = "auto";
			return ;
		}
		var wrapW = img_wrap.offsetWidth-20;
		for (var i = 0; i < images_a.length; ++i) {
				var image_a = images_a[i];
				if (image_align_type == 1) {
						image_a.style.width = (wrapW / 3 >> 0) + "px";
				} else if (image_align_type == 2) {
						image_a.style.width = (wrapW / 2 >> 0) + "px";
				}
		}
		// var images_a = document.querySelectorAll('.image_wrap>a');
		for (var i = 0; i < images_a.length; ++i) {
				var image_a = images_a[i];
				image_a.style.height = image_a.offsetWidth + "px";
		}
	}else{
		// 转发原贴
		var images_a_2 = document.querySelectorAll('.source_image_wrap>a');
		var img_wrap_2 = document.querySelectorAll('.source_image_wrap')[0];

		// if(isOnePic){
		// 	images_a_2[0].style.width = "100%";
		// 	images_a_2[0].style.height = "auto";
		// 	return ;
		// }

		var wrapW_2 = img_wrap_2.offsetWidth-30;
		for (var i = 0; i < images_a_2.length; ++i) {
				var image_a_2 = images_a_2[i];
				if (image_align_type == 1) {
						image_a_2.style.width = (wrapW_2 / 3 >> 0) - 2 + "px";
				} else if (image_align_type == 2) {
						image_a_2.style.width = (wrapW_2 / 2 >> 0) - 2 + "px";
				}
		}
		// var images_a = document.querySelectorAll('.source_image_wrap>a');
		for (var i = 0; i < images_a_2.length; ++i) {
				var image_a_2 = images_a_2[i];
				image_a_2.style.height = image_a_2.offsetWidth + "px";
		}
	}
}

function onImgLoad(obj,isOnePic) {
	var image = obj;
	var image_a = obj.parentNode;
	var image_a_div = obj.parentNode.parentNode;
	image.style.width = "100%";
	if(isOnePic){
		image.style.height = "auto";
		image.style.width = "100%";
		image.style.marginTop = "0px";
		image.style.marginLeft = "0px";
		image_a_div.style.marginLeft = "0px";
		image.style.transform = "translate(0%,0%)";
		image.style.position = "static";
		return ;
	}
	if (image.offsetHeight < image_a.offsetHeight && image.offsetHeight < image.offsetWidth) {
			image.style.height = "100%";
			image.style.width = "";
	}else{

	}
	// image.style.marginTop = (image_a.offsetHeight - image.offsetHeight) / 2 + "px";
	// image.style.marginLeft = (image_a.offsetWidth - image.offsetWidth) / 2 + "px";
}

function setInitial9PicHeight(){
	if(data.post_pic_url.length>0){  //设置九宫格默认高度
		var image_align_type = data.post_pic_url.length==4?2:1;
		var wrapW = window.screen.width;
		if(image_align_type == 1){
			if(data.post_pic_url.length == 1){ // 只有一张图时放大图片
				data.Pic9Height = "auto";
			}else{
				data.Pic9Height = ((wrapW/3>>0)-2)*Math.ceil(data.post_pic_url.length/3)+"px";
			}
		}else{
			data.Pic9Height = ((wrapW/2>>0)-2)*2+"px";
		}
	}
	if(data.source_post_pic_url.length>0){  //转发的原贴设置九宫格默认高度
		var image_align_type_2 = data.source_post_pic_url.length==4?2:1;
		var wrapW = window.screen.width-80;
		if(image_align_type_2 == 1){
			data.SourcePic9Height = ((wrapW/3>>0)-2)*Math.ceil(data.source_post_pic_url.length/3)+"px";
		}else{
			data.SourcePic9Height = ((wrapW/2>>0)-2)*2+"px";
		}
	}
}

function operateAfterRender(){
	// 初始化要传给app的值
	// emSendPageInfoToAPP();

	//获取关注状态
	// getIsFollowPoster();
	// getUserFollowingAndBlackInfo();

	// window.onscroll = addScrollListener;

	// 九宫格
	if(data.post_pic_url.length>0){
		var image_align_type = data.post_pic_url.length==4?2:1;
		var isOnePic = data.post_pic_url.length==1?true:false;
		var a_image_wrap = document.getElementById("image_wrap").getElementsByTagName("a");
		for (var i = 0; i < a_image_wrap.length; i++) {
			onImgLoad(a_image_wrap[i].getElementsByTagName("img")[0],isOnePic);
		}
		handleImageWrap(image_align_type,isOnePic,1);
		document.getElementById("image_wrap").style.opacity = "1";
	}
	var image_wrap = document.getElementById("image_wrap");
	image_wrap.onclick = function(e){
		if(e.target.tagName != "IMG") return;
		if(e.target.id*1<0) return;
		var param = {
				"pos": data.post_pic_url.indexOf(e.target.id),
				"images": []
			}
		var images = [];
		for (var i = 0; i < data.post_pic_url2.length; i++) {
			var obj = {
				"url":data.post_pic_url2[i]
			}
			images.push(obj);
		}
		param.images = images;
		if(SysFrom == "1"){
			window.location.href = "EastMoneyApp:image(position="+param.pos+" url="+param.images[param.pos].url+" )";
		}else{
			helper.Bridge.emH5ImgGallary(param);
		}
	}

	// 转发原贴的九宫格
	if(data.source_post_pic_url.length>0){
		var image_align_type_2 = data.source_post_pic_url.length==4?2:1;
		var a_image_wrap_2 = document.getElementById("source_image_wrap").getElementsByTagName("a");
		for (var i = 0; i < a_image_wrap_2.length; i++) {
			onImgLoad(a_image_wrap_2[i].getElementsByTagName("img")[0],false);
		}
		handleImageWrap(image_align_type_2,false,2);
		document.getElementById("source_image_wrap").style.opacity = "1";
	}
	var image_wrap_2 = document.getElementById("source_image_wrap");
	image_wrap_2.onclick = function(e){
		if(e.target.tagName != "IMG") return;
		if(e.target.id*1<0) return;
		var param_2 = {
				"pos": data.source_post_pic_url.indexOf(e.target.id),
				"images": []
			}
		var images_2 = [];
		for (var i = 0; i < data.source_post_pic_url2.length; i++) {
			var obj = {
				"url":data.source_post_pic_url2[i]
			}
			images_2.push(obj);
		}
		param_2.images = images_2;
		helper.Bridge.emH5ImgGallary(param_2);
	}

	var _tables = document.getElementsByTagName("table");
	for (var i = 0; i < _tables.length; i++) {
		var _tmpTableBox = document.createElement("div");
		_tmpTableBox.className = "tableBox";
		_tables[i].parentNode.insertBefore(_tmpTableBox, _tables[i]);
		_tmpTableBox.insertBefore(_tables[i], null);
		var _tipTxt = document.createElement("div");
		_tipTxt.className = "tableBoxTip";
		_tipTxt.innerHTML = "左右拖动表格，可查看剩余表格内容";
		_tmpTableBox.insertBefore(_tipTxt, _tmpTableBox.firstChild)
	}
	// var _contentDivs = document.getElementsByTagName("div");
	// for (var i = 0; i < _contentDivs.length; i++) {
	// 	if (_contentDivs[i].className == "content" || _contentDivs[i].className == "refcon") {
	// 		var _html = helper.text.showface(_contentDivs[i].innerHTML);
	// 		_contentDivs[i].innerHTML = _html
	// 	}
	// }
	var quoteImgs = document.querySelectorAll("img[data-code]");
	var len = quoteImgs.length;
	for (var i = 0; i < len; ++i) {
		var img = quoteImgs[i];
		img.removeAttribute('height')
	}
	var isHttp = window.location.href.indexOf("http://") > -1 ? true : false;
	if (appVersion >= "7005000") {
		if (document.getElementsByClassName("cfh_lkvideo_tag").length > 0) {
			document.getElementsByClassName("cfh_lkvideo_tag")[0].id = "cfh_lkvideo_tag";
			var newCSSDom = document.createElement("link");
			newCSSDom.setAttribute("rel", "stylesheet");
			newCSSDom.setAttribute("type", "text/css");
			newCSSDom.setAttribute("href", "//h5-qas.lvb.eastmoney.com/frontend/elPlayer/static/css/elplayer.min.css");
			document.getElementsByTagName("head")[0].appendChild(newCSSDom);
			var script = document.createElement("script");
			script.src = "//h5-qas.lvb.eastmoney.com/frontend/elPlayer/static/js/elplayer.js";
			var done = false;
			script.onload = script.onreadystatechange = function() {
				if (!done && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) {
					done = true;
					var width = window.innerWidth;
					var player = new elPlayer("cfh_lkvideo_tag", {
						width: width,
						height: 175 * (width * 1) / 305,
						autoplay: false,
						src: document.getElementsByClassName("cfh_lkvideo_tag")[0].dataset.id,
						poster: document.getElementsByClassName("cfh_lkvideo_tag")[0].dataset.cover.replace("http://", isHttp ? "http://" : "https://"),
						controllerbar: {
							fullscreen: false,
							virtualFullscreen: false
						},
						swf: '//gbfek.dfcfw.com//libs/elplayer/v2/emlive.swf',
					}, function() {
						window.player = this;
						// helper.Bridge.getNetworkStateAppInfo();
					});
					script.onload = script.onreadystatechange = null;
					document.getElementsByTagName("head")[0].removeChild(script)
				}
			};
			document.getElementsByTagName("head")[0].appendChild(script)
		}
	} else {
		if (document.getElementsByClassName("cfh_lkvideo_tag").length > 0) {
			var img = document.createElement("img");
			img.width = document.body.scrollWidth;
			img.height = 175 * (document.body.scrollWidth * 1) / 305;
			img.src = document.getElementsByClassName("cfh_lkvideo_tag")[0].dataset.cover.replace("http://", isHttp ? "http://" : "https://");
			document.getElementsByClassName("cfh_lkvideo_tag")[0].appendChild(img)
		}
	}
	setTimeout(function() {
		try {
			var postDom = document.getElementById("postid");
			if (postDom && postDom.value == 754649973 && typeof(appPlat) != "undefined") {
				var linkMap = [{
					"android": "dfcft://webh5?url=https://gbfek.dfcfw.com/gubaapi/app_embed/webToH5.html?location=https://hk.eastmoney.com/news/1532,20180413856618385.html",
					"iphone": "eastmoney://wireless/h5/trade?url=https://gbfek.dfcfw.com/gubaapi/app_embed/webToH5.html?location%3Dhttps://hk.eastmoney.com/news/1532,20180413856618385.html"
				}, {
					"android": "dfcft://webh5?url=https://gbfek.dfcfw.com/gubaapi/app_embed/webToH5.html?location=https://hk.eastmoney.com/news/1532,20180413856617921.html",
					"iphone": "eastmoney://wireless/h5/trade?url=https://gbfek.dfcfw.com/gubaapi/app_embed/webToH5.html?location%3Dhttps://hk.eastmoney.com/news/1532,20180413856617921.html"
				}, {
					"android": "dfcft://webh5?url=https://gbfek.dfcfw.com/gubaapi/app_embed/webToH5.html?location=https://finance.eastmoney.com/news/1344,20180413856761664.html",
					"iphone": "eastmoney://wireless/h5/trade?url=https://gbfek.dfcfw.com/gubaapi/app_embed/webToH5.html?location%3Dhttps://finance.eastmoney.com/news/1344,20180413856761664.html"
				}, ];
				var nodelist = document.querySelectorAll("strong");
				var len = nodelist.length;
				for (var i = 0; i < len; ++i) {
					var node = nodelist[i];
					var linkAddr = null;
					if (node.innerHTML.indexOf("港币贬值背后的美元霸权") >= 0) {
						linkAddr = linkMap[0][appPlat]
					}
					if (node.innerHTML.indexOf("港汇跌近7.85干预底线：并非危机再现 套息交易乃主因") >= 0) {
						linkAddr = linkMap[1][appPlat]
					}
					if (node.innerHTML.indexOf("港汇告急！金管局32亿托市 20年前世纪大战历历在目") >= 0) {
						linkAddr = linkMap[2][appPlat]
					}
					if (linkAddr) {
						node.innerHTML = '<a href="' + linkAddr + '">' + node.innerHTML + '</a>'
					}
				}
			}
		} catch (e) {}
	}, 300);
	var img_arr = document.getElementsByTagName("img");
	for (var i = 0; i < img_arr.length; i++) {
		if (img_arr[i].parentNode && img_arr[i].parentNode.href && (img_arr[i].parentNode.href.indexOf("/stockdetail/") > 0 || img_arr[i].parentNode.href.indexOf("/stock?stockcode") > 0)) {
			img_arr[i].parentNode.setAttribute("class", "ckhq")
		}
	}
	if (document.getElementsByClassName("look_pdf_top")[0] != undefined) {
		document.getElementsByClassName("look_pdf_top")[0].setAttribute("class", "look_pdf_top blue")
	}
	if (document.getElementsByClassName("look_pdf_bottom")[0] != undefined) {
		document.getElementsByClassName("look_pdf_bottom")[0].setAttribute("class", "look_pdf_bottom blue")
	}
	var b_arr = document.getElementsByTagName("b");
	for (var i = 0; i < b_arr.length; i++) {
		if (b_arr[i].innerHTML == "提示：本文属于研究报告栏目，仅为机构或分析人士对一只股票的个人观点和看法，并非正式的新闻报道，本网不保证其真实性和客观性，一切有关该股的有效信息，以沪深交易所的公告为准，敬请投资者注意风险。") {
			b_arr[i].setAttribute("class", "tishi")
		}
		if (b_arr[i].innerHTML == "提示：本网不保证其真实性和客观性，一切有关该股的有效信息，以沪深交易所的公告为准，敬请投资者注意风险。") {
			b_arr[i].setAttribute("class", "tishi")
		}
	}
}

function getArticleContent(){
	// helper.net.jsonp("/read/api/Article/Post/ArticleContent", {  // 7.7
	// 	postid: postid,
	// 	type:type?type:0
	// }, "jsonp").success(function(res) {
	helper.net.getjsonp_core({
			url:"/content/api/Post/ArticleContent",  // 7.8
			data:{
					postid: postid,
					type:type?type:0
			},
			type:"POST",
			success:function(res){
				data.post = res.post;
				data.post.rc = 1;
				data.showArticle = "blockShow";
				data.showNoArticle = "hide";
				data.post_id = res.post.post_id;
				data.post_type = res.post.post_type;
				data.user_id = res.post.post_user.user_id;
				data.avator = "https://avator.eastmoney.com/qface/"+ data.user_id +"/166?v="+ new Date().getTime();
				data.user_v = res.post.post_user.user_v;
				data.user_nickname = res.post.post_user.user_nickname;
				data.user_influ_level = helper.text.formatStars(res.post.post_user.user_influ_level);
				data.user_age = res.post.post_user.user_age;
				data.isMajiaOrPostUser = res.post.post_user.user_is_majia?"hide":"show";
				data.isMajia = res.post.post_user.user_is_majia?"hide":"show";
				data.isMajiaForClass = res.post.post_user.user_is_majia?"zx":"";
				data.post_display_time = helper.text.formatTime(res.post.post_display_time);
				data.post_publish_time = helper.text.formatTime(res.post.post_publish_time);
				data.post_from = res.post.post_from;
				data.isShowPdf = ((res.post.post_type==3||res.post.post_type==2)&&res.post.post_pdf_url!=""?"show":"hide");
				data.post_pdf_url = res.post.post_pdf_url;
				data.post_pic_url = res.post.post_pic_url;
				data.post_pic_url2 = res.post.post_pic_url2;
				data.source_post_pic_url = res.post.source_post_pic_url;
				data.source_post_pic_url2 = res.post.source_post_pic_url2;
				data.post_content = helper.text.showface(res.post.post_content.replace(/\\"/g,'"'));
				data.post_abstract = res.post.post_abstract;
				data.post_title = res.post.post_title;
				data.isShowTitle = (res.post.post_title==res.post.post_content||res.post.post_title==""||res.post.post_type=="42"||res.post.post_type=="38"||res.post.post_type=="37"||res.post.post_type=="11")?"hide":"show";
				data.isShowSourceTitle = (res.post.source_post_title==res.post.source_post_content||res.post.source_post_title==""||res.post.source_post_type=="42"||res.post.source_post_type=="38"||res.post.source_post_type=="37"||res.post.source_post_type=="11")?"hide":"show";
				data.post_click_count = helper.text.formatNum(res.post.post_click_count);
				data.frombarname = data.stockbar_name = res.post.post_guba.stockbar_name;
				data.frombarinfo = JSON.stringify(res.post.post_guba);
				if(res.post.post_like_count>0){
					if(res.post.post_like_count<10000){
						data.post_like_count = res.post.post_like_count;
					}else if(res.post.post_like_count>=10000 && res.post.post_like_count<100000){
						data.post_like_count = (res.post.post_like_count/10000).toFixed(1)+"万";
					}else if(res.post.post_like_count>=100000){
						data.post_like_count = "10万+"
					}
				}else{
					data.post_like_count = "";
				}
				data.barUrl = "";
				data.post_is_like = (res.post.post_is_like?"liked":"unlike");
				data.user_is_majia = res.post.post_user.user_is_majia;
				data.stockbar_quote = res.post.post_guba.stockbar_quote;
				data.stockbar_code = res.post.post_guba.stockbar_code;
				data.stockbar_exchange = res.post.post_guba.stockbar_exchange;
				data.source_post_id = res.post.source_post_id;
				data.isShowZF = data.source_post_id?"blockShow":"hide";
				data.source_post_title = res.post.source_post_title;
				data.source_post_content = helper.text.showface(res.post.source_post_content.replace(/\\"/g,'"'));
				if(data.source_post_content.substr(-3,3) === "..."){
					data.source_post_content = data.source_post_content + "<span class='formore'>全文</span>"
				}
				data.source_post_user_id = res.post.source_post_user_id;
				data.source_post_user_is_majia = res.post.source_post_user_is_majia;
				data.source_post_user_nickname = res.post.source_post_user_nickname;
				data.passing = data.post.post_state == 2?true:false;
				data.isShowIMG = (res.post.post_from_num==5||res.post.post_pic_url.length==0)?"hide":"show";
				data.isShowSourceIMG = (res.post.source_post_pic_url.length==0)?"hide":"show";
				data.isShowPic = "hide";
				if(res.post.post_guba.stockbar_type==105){
					data.isShowFromBar = "hide";
				}else if(res.post.post_guba.stockbar_type==205){ // 转发帖 显示 原贴来自吧
					if(res.post.post_guba.stockbar_external_code == "zf"){
						if(!data.post.source_post_guba.stockbar_name){
							data.isShowFromBar = "hide"
						}else{
							data.frombarname = data.post.source_post_guba.stockbar_name;
							data.frombarinfo = JSON.stringify(data.post.source_post_guba);
							data.isShowFromBar = "show";
						}
					}else{
						data.isShowFromBar = "hide"
					}
				}else{
					data.isShowFromBar = "show"
				}

				if(res.post.post_guba.stockbar_external_code=="zf" && res.post.post_pic_url2.length>0){ // 转发贴有图片
					data.isShowIMG = 'hide';
					data.isShowPic = "inlineShow";
					data.post_content = data.post_content==""?"图片评论":data.post_content;
				}

				if(res.post.post_type == 11 && res.post.post_state != 1 && res.post.post_content.indexOf("【问】") != -1){
					var strMarket = res.post.post_guba.stockbar_exchange == 100?"上证e互动":"互动易";
					var question = res.post.post_content.substring(3,res.post.post_content.indexOf("【答】"));
					var answerList = res.post.post_content.substring(res.post.post_content.indexOf("【答】")).split("§");
					answerList[0] = answerList[0].split("¶");
					var isShowState = answerList[0][1]&&answerList[0][1].length>0?"show":"hide";
					var isShowTime = answerList[0][2]&&answerList[0][2].length>0?"show":"hide";
					var post_content = '<div class="t_ar_content_t">' +
															    '<div class="t_ar_content_title" id="article_title">' +
															        '<div class="q_body">' +
															            '<span class="qa_icon ques">问</span>' +
															            '<span class="q_main">'+question+'</span>' +
															        '</div>' +
															    '</div>' +
															'</div>' +
															'<div class="t_ar_content_c" id="article_text" style="word-break: break-all; word-wrap: break-word;">' +
															    '<div class="a_body">' +
															       ' <span class="qa_icon ans">答</span>' +
															        '<span class="a_main">' +
															            '<span class="answerer">'+ res.post.post_guba.stockbar_name.substring(0,res.post.post_guba.stockbar_name.length-1) +'：</span>' +
															            '<span class="a_content">' +
															              answerList[0][0].substring(answerList[0][0].indexOf("：")+1)+
															              '<span class="red '+ isShowState +'">（'+ answerList[0][1] +'）</span>' +
															            '</span>' +
															        '</span>' +
															        '<p class="a_details">' +
															            '<span class="a_from">' +
															              '<span style="margin-right: 10px; float: left;">' +
															                '(来自<span>'+ strMarket +'</span>)' +
															              '</span>' +
															              '<span class="'+ isShowTime +'" style="float: left;">' +
															                '答复时间' +
															                '<span class="a_timespan">'+ answerList[0][2] +'</span>' +
															              '</span>' +
															              '<div class="clear"></div>' +
															            '</span>' +
															        '</p>';
					if(answerList.length>1){
						for (var i = 1; i < answerList.length; i++) {
							answerList[i] = answerList[i].split("¶");
							if(answerList[i][0].length>0){
								var isShowState2 = answerList[i][1]&&answerList[i][1].length>0?"show":"hide";
								var isShowTime2 = answerList[i][2]&&answerList[i][2].length>0?"show":"hide";
								post_content = post_content + '<span class="a_main">' +
																									'<span class="a_content">' +
																										answerList[i][0].substring(answerList[i][0].indexOf("：")+1) +
																										'<span class="red '+ isShowState2 +'">（'+ answerList[i][1] +'）</span>' +
																									'</span>' +
																							'</span>' +
																							'<p class="a_details">' +
																									'<span class="a_from">' +
																										'<span style="margin-right: 10px; float: left;">' +
																											'(来自<span>'+ strMarket +'</span>)' +
																										'</span>' +
																										'<span class="'+ isShowTime2 +'" style="float: left;">' +
																											'答复时间' +
																											'<span class="a_timespan">'+ answerList[i][2] +'</span>' +
																										'</span>' +
																										'<div class="clear"></div>' +
																									'</span>' +
																							'</p>';
							}
						}
						data.post_content = post_content;
					}else{
						data.post_content = post_content + '</div></div>';
					}
				}

				setInitial9PicHeight();

				document.getElementById("article_wrap").innerHTML = article_tpl(data);

				if((res.post.post_type >= 27 && res.post.post_type < 32)||(res.post.source_post_type >= 27 && res.post.source_post_type < 32)){   //mary写的内嵌
					if(SysFrom == 1){ // 内嵌的 非PE Future
						helper.net.loadResource("https://gbfek.dfcfw.com/gubaapi/app_embed/online/guba_charts.css");
						helper.net.loadResource("https://gbfek.dfcfw.com/gubaapi/app_embed/online//guba_zjchart.css");
						helper.net.loadResource("https://gbfek.dfcfw.com/gubaapi/app_embed/online//em.guba.charts.js");
						helper.net.loadResource("https://gbfek.dfcfw.com/gubaapi/app_embed/online//guba_zjchart.js",function(){
							setTimeout(function(){
								if (gubaAppInsert.getClass("guba_app_insert")[0] != undefined) {
									gubaAppInsert.guBaChartsFn();
									gubaAppInsert.bigDataFn();
								}
							},500)
						});
					}else{
						helper.net.loadResource("./guba_charts.css");
						helper.net.loadResource("./guba_zjchart.css");
						helper.net.loadResource("./em.guba.charts.js");
						helper.net.loadResource("./guba_zjchart.js",function(){
							setTimeout(function(){
								if (gubaAppInsert.getClass("guba_app_insert")[0] != undefined) {
									gubaAppInsert.guBaChartsFn();
									gubaAppInsert.bigDataFn();
								}
							},500)
						});
					}
				}

				// if (res.post.post_type == "35" || res.post.post_type == "34") {
					// setTimeout(function() {
					// 	if (typeof(window.webviewreloadforimage) != "undefined") {
					// 		window.webviewreloadforimage()
					// 	}
					// }, 100)
				// }

				setTimeout(function(){
					
					if (typeof(window.webviewreloadforimage) != "undefined") {
						window.webviewreloadforimage()
					}

					operateAfterRender();
				},500)
			},
			error:function(error){
				data.showArticle = "hide";
				data.showNoArticle = "blockShow";
				data.post = null;
				document.getElementById("article_wrap").innerHTML = article_tpl(data);
				setTimeout(function(){
					emSendPageInfoToAPP();
				},800)
			}
		})
		// .error(function(msg,error){
		// 	data.showArticle = "hide";
		// 	data.showNoArticle = "blockShow";
		// 	data.post = error;
		// 	document.getElementById("article_wrap").innerHTML = article_tpl(data);
		//
		// 	setTimeout(function(){
		// 		emSendPageInfoToAPP();
		// 	},800)
		// });
}

helper.observer.register("article_showTip", showTip, this);
function showTip(obj) {
	if (obj['data']['deviceInfo']['network'] && obj['data']['deviceInfo']['network'] == "WIFI") {
		window.player.play()
	} else {
		var mask = document.createElement("div");
		mask.id = "mask";
		mask.onclick = function() {
			this.parentNode.removeChild(this);
			var maskTip = document.createElement("div");
			maskTip.id = "maskTip";
			maskTip.onclick = function() {
				this.parentNode.removeChild(this);
				window.player.play()
			};
			document.getElementById("cfh_lkvideo_tag").appendChild(maskTip);
			var text1 = document.createElement("div");
			text1.className = "text1";
			text1.innerHTML = "您正在使用非wifi网络，播放将消耗较多流量";
			document.getElementById("maskTip").appendChild(text1);
			var text2 = document.createElement("div");
			text2.className = "text2";
			text2.innerHTML = "继续播放";
			document.getElementById("maskTip").appendChild(text2)
		};
		document.getElementById("cfh_lkvideo_tag").appendChild(mask)
	}
}

// 回调函数
window.setTheme = function(type) {
	setTimeout(function() {
		if (type == "b") {
			if (!helper.file.isInclude("theme_black.css")) {
				var head = document.getElementsByTagName('head')[0];
				var link = document.createElement('link');
				link.href = location.origin.indexOf("gubawebcs") > 0 || location.origin.indexOf("ycao.eastmoney.com") > 0 ? "https://gubawebcs.eastmoney.com/app_embed/theme_black.css" : "./theme_black.css";
				link.rel = 'stylesheet';
				link.type = 'text/css';
				head.appendChild(link)
			}
			document.getElementsByTagName("html")[0].className = "theme_black"
		} else if (type == "w") {
			document.getElementsByTagName("html")[0].className = "theme_white"
		} else{
			document.getElementsByTagName("html")[0].className = "theme_classic"
		}
	}, 10)
}
window.handleFollowUser = function(type){ //type:1 添加关注 type:非1 取消关注
	if(type == 1){  //加关注
		helper.user.checkLogin(function(){  //检查是否登录
			if(helper.user.isLogin()){
				if(data.post.post_user.is_blackuser==1){ //被关注人是你的黑名单
					helper.Bridge.emComfirm({
							"title": "",
							"content": "该用户为您的屏蔽用户，确定解除屏蔽并关注此人？",
							"okbt": {
									"name": "确定",
									"event": "removeMyBlackUser"
							},
							"cnacelbt":  {
									"name": "取消",
									"event": ""
							}
					})
				}else{
					window.addFollowUser();
				}
			}else{
				helper.user.login();//調用app登樓
			}
		});
	}else{ // 取消关注
		window.cancelFollowUser();
	}
}
window.removeMyBlackUser = function(){
	// helper.net.jsonp("https://gubaapihttps.eastmoney.com/v3/write/Common/RemoveMyBlackUser.aspx", {
	// 	uid: data.user_id
	// }, "jsonp").success(function(res) {
	helper.net.getjsonp_core({
		url:"/userinfoopt/api/UserBlackList/RemoveMyBlackUser",  // 7.8
		data:{
				uid: data.user_id
		},
		type:"POST",
		success:function(res){
			data.post.post_user.is_blackuser="0";
			window.addFollowUser();
		},
		error:function(req){
			helper.Bridge.emAlert({msg:"解除黑名单失败"})
		}
	})
}
window.addFollowUser = function(){
	var follow = document.getElementById("follow_wrap").children[0];
	var unfollow = document.getElementById("follow_wrap").children[1];
	// helper.net.jsonp("https://gubaapihttps.eastmoney.com/v3/write/User/Follow/FollowUser.aspx", {   //7.7
	// 	followuid: data.user_id
	// }, "jsonp").success(function(res) {
	helper.net.getjsonp_core({
		url:"/followopt/api/Follow/FollowUser",  // 7.8
		data:{
				followuid: data.user_id
		},
		type:"POST",
		success:function(res){
			data.isfollow = "isfollowed";
			follow.className = "follow_btn follow right show";
			unfollow.className = "follow_btn unfollow right hide";
			helper.Bridge.emSendBackInfoToAPP({"topData": {"subscribeStatus":1}});
			helper.Bridge.emAlert({msg:'关注成功'})
		},
		error:function(req){
			helper.Bridge.emAlert({msg:"关注失败"})
		}
	})
}
window.cancelFollowUser = function(){
	var follow = document.getElementById("follow_wrap").children[0];
	var unfollow = document.getElementById("follow_wrap").children[1];
	// helper.net.jsonp("https://gubaapihttps.eastmoney.com/v3/write/User/Follow/CancelFollowUser.aspx", {  // 7.7
	// 	followuid: data.user_id
	// }, "jsonp").success(function(res) {
	helper.net.getjsonp_core({
		url:"/followopt/api/Follow/CancelFollowUser",  // 7.8
		data:{
				followuid: data.user_id
		},
		type:"POST",
		success:function(res){
			data.isfollow = "notfollow";
			follow.className = "follow_btn follow right hide";
			unfollow.className = "follow_btn unfollow right show";
			helper.Bridge.emSendBackInfoToAPP({"topData": {"subscribeStatus":0}});
			helper.Bridge.emAlert({msg:'取消关注成功'});
		},
		error:function(req){
			helper.Bridge.emAlert({msg:"取消关注失败"});
		}
	})
}
window.handleJump = function(){
	if(!data.user_is_majia){   //个人
		if(data.user_nickname!=""){
			// var url = helper.Bridge.isIOS()?("stockbarselfpage?uid="+data.user_id+"&anchor=1"):("gubauserhome?uid="+data.user_id+"&anchor=1");
			helper.Bridge.jumpToUser(data.user_id);
		}
	}else{  //资讯
		if(data.stockbar_quote == 1){  // 有行情的跳转个股列表页
			var stockbar_code = data.stockbar_code;
			if(data.stockbar_exchange == 100 || data.stockbar_exchange == 101){
				stockbar_code = helper.stock.getMarket(data.stockbar_exchange)+data.stockbar_code;
			}else if(data.stockbar_exchange == 106){
				stockbar_code = stockbar_code.slice(0,2) + "|" + stockbar_code.slice(2);
			}else{
				stockbar_code = data.post.post_guba.stockbar_market.split(".")[1]+"|"+data.post.post_guba.stockbar_market.split(".")[0];
			}
			helper.Bridge.emH5ToStockList(stockbar_code,data.stockbar_name.substring(0,data.stockbar_name.length-1));
		}else{ //没行情的跳转主题吧
			helper.Bridge.emH5ToStockBar(data.stockbar_code,data.stockbar_name.substring(0,data.stockbar_name.length-1));
		}
	}
}
window.openPDF = function(url){
	if(product == "PE"){   //为私募App兼容
		helper.Bridge.triggerPageActionForPE({"type":"openPDF", "param":{"url":url}})
	}else if(SysFrom == "1"){  //为老版本各种app兼容 主包7.7以下内嵌页等等
		window.location.href = "EastMoneyApp:source(url="+data.post_pdf_url+" mimetype=application/octet-stream)";
	}else{
		helper.Bridge.triggerPageAction({"type":"openPDF", "param":{"url":url}})
	}
}
window.jumpToUserorBar = function(id,name){
	if(name!= null && name.substr(-2) != "资讯"){  // 个人
		helper.Bridge.jumpToUser(id);
	}else{   // xx资讯
		if(data.post.source_post_guba.stockbar_quote == 1){  // 有行情的跳转个股列表页
			var stockbar_code = data.post.source_post_guba.stockbar_exchange;
			if(data.post.source_post_guba.stockbar_exchange == 100 || data.post.source_post_guba.stockbar_exchange == 101){
				stockbar_code = helper.stock.getMarket(data.post.source_post_guba.stockbar_exchange)+data.post.source_post_guba.stockbar_code;
			}else if(data.post.source_post_guba.stockbar_exchange == 106){
				stockbar_code = stockbar_code.slice(0,2) + "|" + stockbar_code.slice(2);
			}else{
				stockbar_code = data.post.source_post_guba.stockbar_market.split(".")[1]+"|"+data.post.source_post_guba.stockbar_market.split(".")[0];
			}
			helper.Bridge.emH5ToStockList(stockbar_code,data.post.source_post_guba.stockbar_name.substring(0,data.post.source_post_guba.stockbar_name.length-1));
		}else{ //没行情的跳转主题吧
			helper.Bridge.emH5ToStockBar(data.post.source_post_guba.stockbar_code,data.post.source_post_guba.stockbar_name.substring(0,data.post.source_post_guba.stockbar_name.length-1));
		}
	}
}
window.jumpToSourcePost = function(id){
	var ev = window.event || event;
  var path = event.path || (event.composedPath && event.composedPath());
	if(path[0].className != "name" && path[0].tagName != "IMG" && path[0].className != "tl_count"){
		helper.Bridge.jumpToSourcePost(id,0);
	}
}
window.jumpToSourcePostReply = function(id){
	var ev = window.event || event;
  var path = event.path || (event.composedPath && event.composedPath());
	if(path[0].className == "tl_count"){
		helper.Bridge.jumpToSourcePostReply(id,0);
	}
}
window.openIMG = function(url,index){
	var pic = data.post_pic_url.length==0?data.post.source_post_pic_url:data.post_pic_url;
	var pic2 = (data.post_pic_url.length==0&&data.post_pic_url2.length==0)?data.post.source_post_pic_url2:data.post_pic_url2;
	if(!pic2){
		return ;
	}
	var param = {
		"pos": index*1+pic.length,
		"images": []
	}
	var images = [];
	if(pic2.length == 0){
		return ;
	}
	for (var i = 0; i < pic2.length; i++) {
		var obj = {
			"url":pic2[i]
		}
		images.push(obj);
	}
	param.images = images;
	helper.Bridge.emH5ImgGallary(param);
}
window.openSourceIMG = function(url,index){
	var pic = data.post_pic_url;
	var pic2 = data.post_pic_url2;
	if(pic2.length == 0){
		return ;
	}
	var param = {
		"pos": index*1,
		"images": []
	}
	var images = [];
	for (var i = 0; i < pic2.length; i++) {
		var obj = {
			"url":pic2[i]
		}
		images.push(obj);
	}
	param.images = images;
	helper.Bridge.emH5ImgGallary(param);
}
window.openOneImg = function(url){
	if(!url){
		url = "https://gbfek.dfcfw.com/gubaapi/app_embed/img/img_error.png";
	}
	var param = {
		"pos": 0,
		"images": [{
			"url":url
		}]
	}
	helper.Bridge.emH5ImgGallary(param);
}
window.emH5ToStockListorBar = function(quote,code,name){
	if(!/^[A-Za-z][A-Za-z]/.test(code.substr(0,2))){   // 前两位不是字母(即不包含市场码) 不跳转
		return ;
	}
	if(quote*1 == 1){
		helper.Bridge.emH5ToStockList(code,(name.substr(-1)=="吧"?name.substring(0,name.length-1):name))
	}else{
		helper.Bridge.emH5ToStockBar(code,(name.substr(-1)=="吧"?name.substring(0,name.length-1):name));
	}
}
window.refresh = function(){
	window.location.reload();
}
window.changePic = function(url,type){
	var index = type == "1"?data.post_pic_url.indexOf(url):data.source_post_pic_url.indexOf(url);
	if(index > -1){
		if(type == "1"){
			document.getElementById("image_wrap").children[index].children[0].src = "https://gbfek.dfcfw.com/gubaapi/app_embed/img/img_error.png";
		}else{
			document.getElementById("source_image_wrap").children[index].children[0].src = "https://gbfek.dfcfw.com/gubaapi/app_embed/img/img_error.png";
		}
	}
}
window.openTopicDetail = function(url){
	if (helper.Bridge.isIOS()) {
		// if(appVersion <= "7008000"){
			window.location.href = 'eastmoney://page/openaccountwithurl?url='+encodeURIComponent(url); // 7.8带顶通
		// }else{
		// 	window.location.href = 'eastmoney://wireless/h5/nonavweb?url='+encodeURIComponent(url); // 7.9透明顶通
		// }
	}else{
		// if(appVersion <= "7008000"){
			window.location.href = 'dfcft://kaihu?url='+encodeURIComponent(url); // 7.8带顶通
		// }else{
		// 	window.location.href = 'dfcft://webh5?titlebartype=trans&url='+encodeURIComponent(url); // 7.9透明顶通
		// }
	}
}
window.jumpToReport = function(id){
	var url = "http://help.eastmoney.com/report/report_h5/page/report.html?report_type=article&systype=1&uid="+id;
	if(!helper.env.isRelease){
		url = "http://test.yscmgr.eastmoney.com/reportEastmoney/h5/report_h5/page/report.html?report_type=article&systype=1&uid="+id;
	}
	if (helper.Bridge.isIOS()) {
		window.location.href = 'eastmoney://page/openaccountwithurl?url='+encodeURIComponent(url); // 7.8带顶通
	}else{
		window.location.href = 'dfcft://kaihu?url='+encodeURIComponent(url); // 7.8带顶通
	}
}

getArticleContent();

if(theme == "black"){
	window.setTheme("b");
}else if(theme == "white"){
	window.setTheme("w");
}else{   // 经典皮肤
	window.setTheme("c");
}



//////////////////
// WEBPACK FOOTER
// ./src/index2.js
// module id = 6
// module chunks = 0